import React from 'react';

import CrudPage from '@modules/cruds/CrudPage';
import UnitForm from './UnitForm';
import * as yup from 'yup'; // for everything
import { defaultConfigComponent } from './Units';

const unitSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  abbreviation: yup.string().required().label('Abbreviation'),
  quantityId: yup.string().required().label('Quantity ID'),
  ownerOrganizationId: yup.string().required().label('Organization'),
});

const UnitPage = props => {
  return (
    <CrudPage
      key={'unitPage'}
      configComponent={defaultConfigComponent}
      form={UnitForm}
      validationSchema={unitSchema}
      defaultValues={{ isSIBasic: false }}
    />
  );
};

export default UnitPage;
